import { Button } from '@cian/ui-kit/button';
import { FC } from 'react';

import style from './LoginStep.css';
import { useDeviceType } from '@cian/ui-kit';

interface ILoginStepProps {
  isAuthDisabled: boolean;
  onAuthClick: () => void;
}

export const LoginStep: FC<ILoginStepProps> = ({ isAuthDisabled, onAuthClick }) => {
  const isMobile = useDeviceType() !== 'desktop';

  return (
    <section className={style['section']}>
      <div className={style['inner']}>
        <div className={style['header']}>
          <span className={style['step-label']}>Шаг 1</span>
          <h2 className={style['title']}>Войдите в ваш личный кабинет на Циан на этой странице</h2>
        </div>
        <Button
          theme="fill_primary"
          size={isMobile ? 'M' : 'L'}
          fullWidth={isMobile}
          disabled={isAuthDisabled}
          onClick={onAuthClick}
        >
          Войти
        </Button>
      </div>
    </section>
  );
};
